// extracted by mini-css-extract-plugin
module.exports = {"controls":"FloatMenu_controls__1oSas","menu":"FloatMenu_menu__3gzsj","icon":"FloatMenu_icon__1uSIA"};